import React, { useEffect, useState } from 'react'
import { Button, Card, message, Row, Table, Upload } from "antd";
import { getCustomersWithPage } from "../../services/serviceCustomer";
import CustomerActions from "./CustomerActions";
import CustomerCreate from "./CustomerCreate";
import AddressesActions from "../addresses/AddressesActions";
import config from "../../config";
import cookieOps from "../../services/cookieOps";
import { SearchOutlined, UploadOutlined } from "@ant-design/icons";
import ERROR_MESSAGE from "../../errorMessages";
import Filter from "../filterWrapper/Filter";
import CustomerFilter from "./CustomerFilter";
import { useLocation } from "@reach/router";

const Customer = ({ navigate }) => {
    const location = useLocation();
    const [openFilter, setOpenFilter] = useState(false)
    const [sortedList, setSortedList] = useState([])
    const [newModal, setNewModal] = useState(false)
    const [filtered] = useState(null)
    const [, setCustomers] = useState([])
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });
    const [filters, setFilters] = useState({
        address: '',
        name: ''
    });

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const page = parseInt(queryParams.get('pn')) || 1;
        const pageSize = parseInt(queryParams.get('ps')) || 10;

        getCustomers(page, pageSize);
    }, [location.search]);

    const getCustomers = (page, pageSize, requestObj = filters) => {
        const mockFilters = { ...requestObj };
        mockFilters.pageSize = pageSize;
        mockFilters.pageNo = Number(page) - 1;

        getCustomersWithPage(mockFilters)
            .then(({ data }) => {
                setCustomers(data.content)
                handlers.sortData(data.content)
                setPagination({
                    ...pagination,
                    current: page,
                    total: data.totalElements,
                    pageSize: pageSize
                })
            })
    }

    const handlers = {
        updater() {
            getCustomers(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            const sorted = list.map(customer => ({
                key: customer.id,
                id: customer.id,
                customerName: customer.name,
                customerCode: customer.code,
                customerSector: customer.sector,
                customerTaxNo: customer.taxNo,
                customerTaxOffice: customer.taxOffice,
                customerWebsite: customer.website,
                customerMobilePhone: customer.mobilePhone,
                customerInternalPhone: customer.internalPhone,
                customerDescription: customer.description,
                customerEmail: customer.email,
                customerFax: customer.fax
            }))
            setSortedList(sorted)
        }
    }
    const toggleFilterDisplay = () => setOpenFilter(!openFilter)
    function handleFilter({ address, name }) {
        const requestObj = {}
        Object.keys(arguments[0]).map(key => requestObj[key] = arguments[0][key])
        setFilters(requestObj)
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);

        return new Promise((resolve => resolve(200)))
    }
    const columns = [
        {
            title: 'Adı',
            dataIndex: 'customerName',
            key: 'customerName'
        },
        {
            title: 'Kodu',
            dataIndex: 'customerCode',
            key: 'customerCode'
        },
        {
            title: 'Sektör',
            dataIndex: 'customerSector',
            key: 'customerSector'
        },
        {
            title: 'Vergi No',
            dataIndex: 'customerTaxNo',
            key: 'customerTaxNo'
        },
        {
            title: 'Vergi Dairesi',
            dataIndex: 'customerTaxOffice',
            key: 'customerTaxOffice'
        },
        {
            title: 'Web Sitesi',
            dataIndex: 'customerWebsite',
            key: 'customerWebsite'
        },
        {
            title: 'Cep Telefonu',
            dataIndex: 'customerMobilePhone',
            key: 'customerMobilePhone'
        },
        {
            title: 'Sabit Hat',
            dataIndex: 'customerInternalPhone',
            key: 'customerInternalPhone'
        },
        {
            title: 'Email',
            dataIndex: 'customerEmail',
            key: 'customerEmail'
        },
        {
            title: 'Fax',
            dataIndex: 'customerFax',
            key: 'customerFax'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <CustomerActions record={record} updater={handlers.updater} />
        }
    ]
    const addressColumns = [
        {
            title: 'Müşteri',
            dataIndex: 'customer',
            key: 'customer'
        },
        {
            title: 'Başlık',
            dataIndex: 'title',
            key: 'title'
        },
        {
            title: 'Adres',
            dataIndex: 'address',
            key: 'address'
        },
        {
            title: 'İşlemler',
            render: (text, record) => <AddressesActions record={record} updater={handlers.updater} />
        }
    ]

    const excelUpload = ({ file }) => {

        if (file.status === 'done') {
            message.success('İşlem Başarılı')
            resetHandler();
        } else if (file.status === 'error') {
            let errors = ERROR_MESSAGE["TR"]
            message.error(errors[file.response.message])
        }
    }

    const handlePaginationChange = (pageNumber, pageSize) => {
        navigate(`?ps=${pageSize}&pn=${pageNumber}`);
    };

    const resetHandler = () => {
        const baseObj = {
            address: '',
            name: ''
        };
        setFilters(baseObj);
        navigate(`?ps=${10}&pn=${1}&rn=${Math.floor(Math.random(1) * 1000)}`);
    }

    return (
        <React.Fragment>
            <Card title={'Müşteri Listesi'}
                extra={
                    [
                        <div key={'ButtonGroupDiv'}>
                            <Button key={'CreateButton'} onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni
                                Ekle </Button>
                            <Upload
                                key={'UploadButton'}
                                accept={'.xls, .xlsx'}
                                action={`${config.baseURL}/customer/import-customer`}
                                headers={{
                                    'Authorization': cookieOps.readCookie('mySweetApple'),
                                    'tenantId': window.localStorage.getItem('tenant')
                                }}
                                onChange={excelUpload}
                            >
                                <Button key={'PrintButton'}>
                                    <UploadOutlined /> Toplu Aktarım
                                </Button>
                            </Upload>
                        </div>
                    ]
                }
            >
                <Row justify={"start"}>
                    <div className={'filter-row-container'} onClick={toggleFilterDisplay}><SearchOutlined /></div>
                </Row>
                <Table
                    scroll={{ x: 'max-content' }}
                    columns={filtered === null ? columns : addressColumns}
                    dataSource={filtered || sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ?
                <CustomerCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}
            {
                <Filter
                    showDrawer={openFilter}
                    closer={toggleFilterDisplay}
                    relatedComponent={'Müşteri'}
                    handler={handleFilter}
                    resetHandler={resetHandler}
                >
                    <CustomerFilter />
                </Filter>
            }
        </React.Fragment>
    )
}
export default Customer